import React, { useState } from "react";
import useCreatePlan from "../../customHooks/CreatePlan/useCreatePlan";
import "./CreatePlan.css";
import { useNavigate, useParams } from "react-router";
import { IoArrowBackCircle } from "react-icons/io5";
import usePermission from "../../utils/usePermission";
import FullPageLoading from "../../components/FullPageLoading/FullPageLoading";
import UnAuthorized from "../UnAuthorized/UnAuthorized";
import { MultiSelect } from "react-multi-select-component";
import { Loader as LoaderIcon } from "react-feather";

const CreatePlan = () => {
  const {
    formData,
    featuresList,
    handleChange,
    handleFeatureChange,
    renderErrorMessage,
    handleBlur,
    handleSubmit,
    selectedFeatureIds,
    selectedFeatures,
    selectedTax,
    setSelectedTax,
    selectOptions,
    billingData,
    handleCheckboxChange,
    handleInputChange,
    setBillingData,
    submitLoading,
    isLoading,
    planVersions,
    dynamicHeaders,
  } = useCreatePlan();
  const { id } = useParams();
  const navigate = useNavigate();
  const canWrite = usePermission("ROLE_CREATE");

  return (
    <>
      {canWrite ? (
        <div className="container mb-20">
          <div className="flex justify-between py-3 topheader rounded-lg">
            <h1 className="title">
              {!id ? "Add Plan" : `Edit Plan ${formData.sName}`}
            </h1>
            <button onClick={() => navigate("/plan")} className="back">
              <IoArrowBackCircle size={20} /> Back
            </button>
          </div>
          {!isLoading ? (
            <div>
              <form onSubmit={handleSubmit}>
                <div className="form-grid">
                  <div className="form-section">
                    <div className="form-group">
                      <label htmlFor="sName">
                        Plan Name <span className="red">*</span>
                      </label>
                      <input
                        type="text"
                        name="sName"
                        id="sName"
                        value={formData.sName}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        placeholder="Enter Plan Name"
                        disabled={id}
                      />
                      {renderErrorMessage("sName") && (
                        <div className="text-left text-small  color_red inputErrorSection">
                          {renderErrorMessage("sName")}
                        </div>
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="sDescription">
                        Plan Description <span className="red">*</span>
                      </label>
                      <textarea
                        id="sDescription"
                        name="sDescription"
                        onBlur={handleBlur}
                        value={formData.sDescription}
                        onChange={handleChange}
                        placeholder="Enter Plan Description"
                      ></textarea>
                      {renderErrorMessage("sDescription") && (
                        <div className="text-left text-small  color_red inputErrorSection">
                          {renderErrorMessage("sDescription")}
                        </div>
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="bIsStandard">
                        Plan Type <span className="red">*</span>
                      </label>
                      <select
                        id="bIsStandard"
                        name="bIsStandard"
                        onBlur={handleBlur}
                        value={formData.bIsStandard}
                        onChange={handleChange}
                      >
                        <option value={""}>Select Option</option>
                        <option value={"custom"}>Custom</option>
                        <option value={"standard"}>Standard</option>
                      </select>
                      {renderErrorMessage("bIsStandard") && (
                        <div className="text-left text-small  color_red inputErrorSection">
                          {renderErrorMessage("bIsStandard")}
                        </div>
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="iCurrencyId">
                        Currency <span className="red">*</span>
                      </label>
                      <select
                        id="iCurrencyId"
                        name="iCurrencyId"
                        onBlur={handleBlur}
                        value={formData.iCurrencyId}
                        onChange={handleChange}
                      >
                        <option value={""}>Select Option</option>
                        {selectOptions.currency.map((currency) => {
                          return (
                            <option value={currency.iCurrencyId}>
                              {currency.sName}({currency.sCode})
                            </option>
                          );
                        })}
                      </select>
                      {renderErrorMessage("iCurrencyId") && (
                        <div className="text-left text-small  color_red inputErrorSection">
                          {renderErrorMessage("iCurrencyId")}
                        </div>
                      )}
                    </div>
                    <div className="form-group">
                      <label htmlFor="sBillingCycle">
                        Billing Cycle <span className="red">*</span>
                      </label>
                      <div className="table-container">
                        <table className="data-table">
                          <thead>
                            <tr>
                              <th>
                                <input
                                  type="checkbox"
                                  name="billingCycles"
                                  checked={billingData.every(
                                    (item) => item?.selected
                                  )}
                                  onChange={(e) =>
                                    setBillingData((prevData) =>
                                      prevData.map((item) => ({
                                        ...item,
                                        selected: e.target.checked,
                                      }))
                                    )
                                  }
                                  onBlur={handleBlur}
                                />
                              </th>
                              <th>Billing</th>
                              <th>Price</th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectOptions.billing.length > 0 && (
                              <>
                                {selectOptions.billing.map((bill) => {
                                  const rowData = billingData.find(
                                    (item) =>
                                      item.iBillingCycleId ===
                                      bill.iBillingCycleId
                                  );

                                  return (
                                    <tr
                                      key={bill.iBillingCycleId}
                                      className={
                                        rowData?.selected ? "" : "disabled-row"
                                      }
                                    >
                                      <td>
                                        <input
                                          type="checkbox"
                                          checked={rowData?.selected}
                                          onChange={() =>
                                            handleCheckboxChange(
                                              bill.iBillingCycleId
                                            )
                                          }
                                        />
                                      </td>
                                      <td>{bill.sName}</td>
                                      <td>
                                        <input
                                          type="text"
                                          name={`billingCycle_${bill.iBillingCycleId}`}
                                          value={rowData?.dPrice}
                                          onChange={(e) =>
                                            handleInputChange(
                                              bill.iBillingCycleId,
                                              e.target.value
                                            )
                                          }
                                          onBlur={handleBlur}
                                          disabled={!rowData?.selected}
                                        />{" "}
                                        {renderErrorMessage(
                                          `billingCycle_${bill.iBillingCycleId}`
                                        ) && (
                                          <div className="text-left text-small color_red inputErrorSection">
                                            {renderErrorMessage(
                                              `billingCycle_${bill.iBillingCycleId}`
                                            )}
                                          </div>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </>
                            )}
                          </tbody>
                        </table>
                      </div>
                      {renderErrorMessage("billingCycles") && (
                        <div className="text-left text-small color_red inputErrorSection">
                          {renderErrorMessage("billingCycles")}
                        </div>
                      )}
                    </div>

                    <div className="form-group">
                      <div className="flex items-center gap-4 h-12 border rounded px-3 bg-white">
                        <label
                          htmlFor="sTax"
                          className="mb-0 whitespace-nowrap"
                        >
                          Tax Inclusive
                        </label>
                        <input
                          type="checkbox"
                          name="sTax"
                          id="sTax"
                          className="w-5 h-5 accent-blue-500"
                          onBlur={handleBlur}
                          checked={formData.sTax}
                          onChange={handleChange}
                        />

                        <>
                          {" "}
                          <label
                            htmlFor="sTax"
                            className="mb-0 whitespace-nowrap"
                          >
                            Tax Percentage <span className="red">*</span>
                          </label>
                          <input
                            type="text"
                            className="flex-grow border-l pl-3 outline-none"
                            placeholder="Enter Tax Percentage"
                            value={selectedTax}
                            onChange={(e) => setSelectedTax(e.target.value)}
                          />
                        </>
                      </div>
                      {renderErrorMessage("sTax") && (
                        <div className="text-left text-small color_red inputErrorSection">
                          {renderErrorMessage("sTax")}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="permissions-tree px-[16px]">
                    <h1 className="text-xl text-center">Configuration Tree</h1>
                    <ol className="wtree text-black">
                      {featuresList?.length > 0 ? (
                        <>
                          {featuresList?.map((featureCategory) => {
                            let headers = ["Configuration Name"];

                            let head =
                              dynamicHeaders.find(
                                (u) =>
                                  u.feature ===
                                  featureCategory.FeatureCategoryName
                              )?.feilds.length > 0
                                ? dynamicHeaders.find(
                                    (u) =>
                                      u.feature ===
                                      featureCategory.FeatureCategoryName
                                  )?.feilds
                                : [];

                            let mainHeaders = [...headers, ...head];
                            return (
                              <table
                                key={featureCategory.FeatureCategoryName}
                                className="feature-table"
                              >
                                <thead>
                                  <tr>
                                    <th colSpan={mainHeaders.length + 1}>
                                      {featureCategory.FeatureCategoryName}
                                    </th>
                                  </tr>

                                  <tr>
                                    <th></th>
                                    {mainHeaders.map((header) => (
                                      <th key={header}>{header}</th>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody>
                                  {featureCategory.Features?.map((module) => {
                                    return (
                                      <tr key={module.iFeatureId}>
                                        <td>
                                          <input
                                            type="radio"
                                            name={
                                              featureCategory.FeatureCategoryName
                                            }
                                            checked={
                                              selectedFeatures[
                                                featureCategory
                                                  .FeatureCategoryName
                                              ]?.featureId === module.iFeatureId
                                            }
                                            onClick={() =>
                                              handleFeatureChange(
                                                featureCategory.FeatureCategoryName,
                                                module.iFeatureId
                                              )
                                            }
                                          />
                                        </td>
                                        <td>{module.sTitle}</td>
                                        {dynamicHeaders
                                          .filter(
                                            (d) =>
                                              d.feature ===
                                              featureCategory.FeatureCategoryName
                                          )
                                          .map((d) => {
                                            return (
                                              <>
                                                {d?.feilds?.map((fa, i) => {
                                                  let value;
                                                  if (
                                                    featureCategory.FeatureCategoryName ===
                                                    "Core"
                                                  ) {
                                                    value =
                                                      module.FeatureConfigs.find(
                                                        (f) =>
                                                          f.sFieldName === fa
                                                      )?.sValue || "-";
                                                  } else if (
                                                    featureCategory.FeatureCategoryName ===
                                                    "Compare"
                                                  ) {
                                                    value =
                                                      module.FeatureConfigs.find(
                                                        (f) => f.sValue === fa
                                                      ) ? (
                                                        <svg
                                                          width="16"
                                                          height="16"
                                                          viewBox="0 0 24 24"
                                                          fill="none"
                                                          stroke="green"
                                                          strokeWidth="3"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                        >
                                                          <path d="M20 6L9 17l-5-5" />
                                                        </svg>
                                                      ) : (
                                                        <svg
                                                          width="16"
                                                          height="16"
                                                          viewBox="0 0 24 24"
                                                          fill="none"
                                                          stroke="red"
                                                          strokeWidth="3"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                        >
                                                          <path d="M18 6L6 18M6 6l12 12" />
                                                        </svg>
                                                      );
                                                  } else if (
                                                    featureCategory.FeatureCategoryName ===
                                                    "Analytics"
                                                  ) {
                                                    value =
                                                      module.FeatureConfigs.find(
                                                        (f) => f.sValue === fa
                                                      ) ? (
                                                        <svg
                                                          width="16"
                                                          height="16"
                                                          viewBox="0 0 24 24"
                                                          fill="none"
                                                          stroke="green"
                                                          strokeWidth="3"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                        >
                                                          <path d="M20 6L9 17l-5-5" />
                                                        </svg>
                                                      ) : (
                                                        <svg
                                                          width="16"
                                                          height="16"
                                                          viewBox="0 0 24 24"
                                                          fill="none"
                                                          stroke="red"
                                                          strokeWidth="3"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                        >
                                                          <path d="M18 6L6 18M6 6l12 12" />
                                                        </svg>
                                                      );
                                                  } else if (
                                                    featureCategory.FeatureCategoryName ===
                                                    "Set-up"
                                                  ) {
                                                    value =
                                                      module.FeatureConfigs.find(
                                                        (f) => f.sValue === fa
                                                      ) ? (
                                                        <svg
                                                          width="16"
                                                          height="16"
                                                          viewBox="0 0 24 24"
                                                          fill="none"
                                                          stroke="green"
                                                          strokeWidth="3"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                        >
                                                          <path d="M20 6L9 17l-5-5" />
                                                        </svg>
                                                      ) : (
                                                        <svg
                                                          width="16"
                                                          height="16"
                                                          viewBox="0 0 24 24"
                                                          fill="none"
                                                          stroke="red"
                                                          strokeWidth="3"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                        >
                                                          <path d="M18 6L6 18M6 6l12 12" />
                                                        </svg>
                                                      );
                                                  } else if (
                                                    featureCategory.FeatureCategoryName ===
                                                    "Support"
                                                  ) {
                                                    value =
                                                      module.FeatureConfigs.find(
                                                        (f) => f.sValue === fa
                                                      ) ? (
                                                        <svg
                                                          width="16"
                                                          height="16"
                                                          viewBox="0 0 24 24"
                                                          fill="none"
                                                          stroke="green"
                                                          strokeWidth="3"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                        >
                                                          <path d="M20 6L9 17l-5-5" />
                                                        </svg>
                                                      ) : (
                                                        <svg
                                                          width="16"
                                                          height="16"
                                                          viewBox="0 0 24 24"
                                                          fill="none"
                                                          stroke="red"
                                                          strokeWidth="3"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                        >
                                                          <path d="M18 6L6 18M6 6l12 12" />
                                                        </svg>
                                                      );
                                                  }

                                                  return (
                                                    <td key={i}>
                                                      {value === "-1"
                                                        ? "Unlimited"
                                                        : value}
                                                    </td>
                                                  );
                                                })}
                                              </>
                                            );
                                          })}
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            );
                          })}
                        </>
                      ) : (
                        <>No Features found!.</>
                      )}
                    </ol>
                    {renderErrorMessage("features") && (
                      <div className="text-left text-small  color_red inputErrorSection">
                        {renderErrorMessage("features")}
                      </div>
                    )}
                  </div>
                </div>
                <div className="text-end fixedBtn">
                  {submitLoading ? (
                    <button
                      className="save-button"
                      style={{ width: "100px" }}
                      disabled={submitLoading}
                    >
                      <LoaderIcon size={20} className="indicator" />
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="save-button"
                      disabled={submitLoading}
                    >
                      {id ? "Update" : "Create"}
                    </button>
                  )}
                </div>
              </form>
              {id && (
                <div className="mt-4">
                  <div className="flex justify-center py-3 topheader rounded-lg">
                    <h1 className="title text-center">Previous Versions</h1>
                  </div>
                  <div className="position-relative border-start border-3 ps-4 border-primary">
                    {planVersions?.slice(1).map((version, index) => (
                      <div
                        key={version.iPlanVersionId}
                        className="mb-5 position-relative"
                      >
                        <div
                          className="position-absolute top-0 start-0 translate-middle bg-primary border border-light rounded-circle shadow"
                          style={{
                            width: "16px",
                            height: "16px",
                            left: "-9px",
                            top: "10px",
                          }}
                        ></div>

                        <div className="card shadow-sm p-4 text-light rounded-3">
                          <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                            <h5 className="mb-0 text-info">
                              {version.sVersion} - {version.sName}
                            </h5>
                            <small className="text-secondary">
                              {new Date(
                                version.dtCreatedAt
                              ).toLocaleDateString()}
                            </small>
                          </div>

                          <p className="text-muted">{version.sDescription}</p>

                          <div className="mt-3 p-3 bg-gray-100 rounded">
                            <h6 className="fw-bold text-black mb-2">
                              Pricing Overview
                            </h6>
                            <div className="d-flex flex-wrap ">
                              {version.BillingCycles?.map((cycle) => (
                                <span
                                  key={cycle.iBillingCycleId}
                                  className="badge text-light bg-gradient bg-primary me-2 mb-1"
                                >
                                  {cycle.sName}:{" "}
                                  {
                                    selectOptions.currency.find(
                                      (curr) =>
                                        curr.iCurrencyId === version.iCurrencyId
                                    )?.sSymbol
                                  }
                                  {cycle.dPrice}
                                </span>
                              ))}
                            </div>
                          </div>
                          <div className="mt-3 p-3 bg-gray-100 rounded">
                            <h6 className="fw-bold text-black mb-2">Taxes</h6>
                            <div className="d-flex flex-wrap ">
                              {version.Taxes?.map((cycle) => (
                                <span
                                  key={cycle.iBillingCycleId}
                                  className="badge text-light bg-gradient bg-primary me-2 mb-1"
                                >
                                  {cycle.sName}
                                </span>
                              ))}
                            </div>
                          </div>
                          <div className="mt-3 p-3 bg-gray-100 rounded">
                            <h6 className="fw-bold text-black mb-2">
                              Features
                            </h6>
                            <div className="d-flex flex-wrap ">
                              {version.Features?.map((cycle) => (
                                <>
                                  {cycle.Configurations.map((config) => (
                                    <span
                                      key={cycle.iBillingCycleId}
                                      className="badge text-light bg-gradient bg-primary me-2 mb-1"
                                    >
                                      {config.sFieldName}:{config.sValue}
                                    </span>
                                  ))}
                                </>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <FullPageLoading />
          )}
        </div>
      ) : (
        <UnAuthorized />
      )}
    </>
  );
};

export default CreatePlan;
